module.exports = __webpack_public_path__ + "img/clock.c3eadfcb.jpg";